import {createContext} from "react";

const MapPropsContext = createContext({});

export const MapPropsProvider = MapPropsContext.Provider;

export default MapPropsContext;
